import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { ChevronRightSolidIcon } from '@compono/ui-icons';
import { IconButton } from '../../IconButton/IconButton.js';

var DatePickerArrowButton = function (_a) {
    var _b = _a.themeKey, themeKey = _b === void 0 ? "datePickerArrowButton" : _b, children = _a.children, _c = _a.direction, direction = _c === void 0 ? "right" : _c, props = __rest(_a, ["themeKey", "children", "direction"]);
    return (jsx(IconButton, __assign({ "data-date-picker-arrow-button": true, "data-direction": direction, themeKey: themeKey }, props, { children: children || jsx(ChevronRightSolidIcon, {}) })));
};

export { DatePickerArrowButton };
//# sourceMappingURL=DatePickerArrowButton.js.map
